module.exports = __webpack_public_path__ + "static/img/img-products-1.52acda6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img-products-1.png
// module id = 149
// module chunks = 2